'use client';
import type React from 'react';

import { useEffect } from 'react';
import { initializeLivePreview } from '@/lib/contentstack-sdk/client';

export function ContentstackProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    initializeLivePreview();
  }, []);

  return <>{children}</>;
}
